import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const LoadingSpinner = ({
    size = 'medium',
    text,
    fullHeight = false,
    color = '#86868B',
}) => {
    const sizeMap = {
        small: { icon: 16, fontSize: '0.75rem', padding: '1rem 0' },
        medium: { icon: 20, fontSize: '0.85rem', padding: '2rem 0' },
        large: { icon: 28, fontSize: '0.95rem', padding: '3rem 0' },
    };

    const sizeConfig = sizeMap[size] || sizeMap.medium;

    return (
        <div
            style={{
                ...styles.container,
                padding: sizeConfig.padding,
                minHeight: fullHeight ? '200px' : 'auto',
            }}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <ArrowPathIcon
                style={{
                    width: sizeConfig.icon,
                    height: sizeConfig.icon,
                    color,
                    animation: 'spin 1s linear infinite',
                }}
                aria-hidden="true"
            />
            {text && (
                <span
                    style={{
                        ...styles.text,
                        fontSize: sizeConfig.fontSize,
                        color,
                    }}
                >
                    {text}
                </span>
            )}
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        width: '100%',
        textAlign: 'center',
    },
    text: {
        fontWeight: '500',
        marginTop: '4px',
    },
};

export default LoadingSpinner;
